import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { Checkbox } from "../../../index";
import { ExpandableIcon } from "../expandable-icon";
export const SelectableTableRow = ({
  id,
  name,
  children,
  className,
  selected,
  onChange = id => ({
    id
  }),
  columns,
  isOpen,
  isSelectable = true,
  onToggle
}) => {
  const classes = classnames([""], className);

  const onChangeHandler = checked => {
    if (typeof onChange === "function") {
      onChange(id);
    }

    return {
      checked
    };
  };

  const onToggleHandler = () => {
    if (children && typeof onToggle === "function") {
      onToggle(id);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: classes,
    onClick: onToggleHandler,
    role: "button"
  }, isSelectable ? /*#__PURE__*/React.createElement("td", {
    className: "px-4 py-2 relative"
  }, children ? /*#__PURE__*/React.createElement(ExpandableIcon, {
    className: "h-6 w-6 absolute my-2",
    style: {
      left: 0,
      top: "5px"
    },
    isOpen: isOpen
  }) : null, /*#__PURE__*/React.createElement(Checkbox, {
    name: name || "select",
    value: id,
    checked: selected,
    onChange: onChangeHandler
  })) : null, columns.map((Column, i) => /*#__PURE__*/React.createElement("td", {
    key: typeof Column === "string" ? `${Column}-${i}` : `row-${id}-col-${i}`,
    className: "px-4 py-2"
  }, typeof Column === "function" ? /*#__PURE__*/React.createElement(Column, null) : Column))), isOpen ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: columns.length + 1,
    className: "pl-16"
  }, children)) : null);
};
SelectableTableRow.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.any,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.any),
  isOpen: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onToggle: PropTypes.func
};